import React, { useState, useEffect } from "react";
import axios from "axios";
import Card from "react-bootstrap/Card";

const DropdownCard = (props) => {
  const [pokemonList, setPokemonList] = useState([]);

  const apiURL =
    "https://pokeapi.co/api/v2/pokemon-species/?offset=" +
    props.range[0] +
    "&limit=" +
    props.range[1];

  const fetchPokemon = (val) => {
    axios
      .get(val)
      .then((res) => {
        const pokemon = res.data;
        setPokemonList(pokemon.results);
      })
      .catch(console.log);
  };

  // fetchPokemon(apiURL);

  useEffect(() => {
    fetchPokemon(apiURL);
  }, []);

  return (
    <Card>
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text>{props.description}</Card.Text>
        <select onChange={props.onChange}>
          {pokemonList.map((pokemon) => {
            return (
              <option key={pokemon.name} value={pokemon.name}>
                {pokemon.name.replace(/^\w/, (c) => c.toUpperCase())}
              </option>
            );
          })}
        </select>
      </Card.Body>
    </Card>
  );
};

export default DropdownCard;
